<template>
  <div class="chat-app">
    <div class="chat">
      <div class="chat-header"> <vs-button v-b-tooltip="{
              title: `Volver`,
              placement: 'top',
              customClass: 'font_tooltip',
            }" circle icon floating @click="$router.push('/helex/Mantenimientos')">
        <i class="fa-solid fa-arrow-left"></i>
        </vs-button> Chat Mantenimiento</div>
      <div class="chat-messages" ref="chatContainer">
        <span v-if='messages.length === 0' style="color:#102444 !important; text-align: center; font-size: large;">No
          hay mensajes</span>
        <div v-for="(message, index) in messages" :key="index"
          :class="(usuario.id == message.de.id ? ' sent-message ' : ' received-message ') + 'mt-2'">
          <div class="text-right mt-1" style="font-style: italic; font-size: 14px">
            <span v-if="usuario.id != message.de.id">{{ message.para.nombre }}</span>
            <span v-else>{{ message.de.nombre }}</span>
            <br><br>
          </div>
          {{ message.mensaje }}
          <div class="text-right mt-1" style="font-style: italic; font-size: 12px">
            {{ $moment.tz(message.fecha, "America/Bogota").format("DD-MM-YYYY HH:mm") }}
          </div>
        </div>
      </div>
      <div class="message-input-container">
        <input v-model="mensaje" class="message-input" placeholder="Escribe un mensaje" />
        <button class="send-button" @click="enviarMensaje">
          Enviar &nbsp;
          <i v-if="enviando" class="fas fa-spinner fa-spin"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    sockets: {
      connect: function () {
        console.log("conectado a cockets. en app.vue***************************************************************");
      },
      nuevo_mensaje: async function (data) {
        let usuario = JSON.parse(localStorage.getItem("setPersonaAct")) || null;
        if (usuario != null) {
          this.getData();
          if (data.para.id === usuario.id && Notification.permission === "granted") {
            new Notification("Nuevo mensaje de " + data.de.nombre, {
              body: data.mensaje,
            });
          }

        }
      },
    },
    data() {
      return {
        enviando: false,
        paraId: null,
        usuario: {},
        id: null,
        messages: [],
        mensaje: "",
        correoPara: null,
        usuarioNombre: null,
        Detalle: { MantenimientoId: null, DeId: null, ParaId: null, Mensaje: null, Fecha: null, Leido: false }
      };
    },
    async mounted() {
      this.usuario = JSON.parse(localStorage.getItem("setPersonaAct"));

      this.id = this.$route.params.IdMantenimiento;
      this.paraId = this.$route.params.id;
      await this.getData();
      this.scrollFix();
    },
    methods: {
      scrollFix() {
        this.$nextTick(() => {
          const container = this.$refs.chatContainer;
          if (container) {
            container.scrollTop = container.scrollHeight;
          }
        });
      },
      async getData() {
        try {
          let res = await this.$store.dispatch("hl_get", {
            path: `MantenimientoChat/GetChatByMantenimientoId/${this.id}/${this.usuario.id}/${this.paraId}`,
          });

          this.correoPara = res.data[0].para.correo;
          this.usuarioNombre = res.data[0].de.nombre;
          if (res.respuesta) {
            this.messages = res.data;
            this.scrollFix();
          } else {
            this.messages = [];
          }
        } catch (error) {
          this.messages = [];
          console.error("err", error);
        }
      },
      async enviarMensaje() {
        try {
          this.enviando = true;
          this.Detalle.ParaId = this.paraId;
          this.Detalle.DeId = this.usuario.id;
          this.Detalle.MantenimientoId = this.id;
          this.Detalle.Fecha = this.$moment.tz(new Date(), "America/Bogota").format("YYYY-MM-DDTHH:mm");
          this.Detalle.Mensaje = this.mensaje;

          await this.$store.dispatch("hl_post", {
            path: "MantenimientoChat/NuevoMensajeChat",
            data: this.Detalle,
          });

          await this.$store.dispatch("postw", {
            path: "enviarNotificacion",
            data: this.Detalle,
          });

          let dataCorreo = {
            Correo: this.correoPara, // 12@helexium.com
            Asunto: "Tienes un nuevo mensaje en el chat de mantenimiento",
            Mensaje: ` Tienes un nuevo mensaje en el chat de mantenimiento de ${this.usuarioNombre} <br><br> ${this.mensaje} <br><br> Revisa tu chat en la plataforma de Helexium`,
          };
          await this.$store.dispatch("hl_post", {
            path: "Persona/EnvioNotificacionCorreoCustom",
            data: dataCorreo,
          });

          this.mensaje = "";
          this.$store.commit("refrescarChat", 0);
          this.clearVarFiles()
          this.getData();
          this.scrollFix();
          this.enviando = false;
        } catch (error) {
          this.enviando = false;
        }
      },
    },
  };
</script>

<style scoped>
  .chat-app {
    display: flex;
    max-width: 80%;
    height: 70vh;
    margin: 0 auto;
    background-color: #afafaf;
  }

  .vs-button {
    border-radius: 25px !important;
  }

  .chat-list {
    width: 20%;
    padding: 20px;
    border-radius: 5%;
    background-color: #e9e9e9;
    border-right: 1px solid #ccc;
    overflow-y: auto;
  }

  .chat-item {
    cursor: pointer;
    padding: 10px;
    border-bottom: 1px solid #292929;
    color: #1b1b1b;
  }

  .chat {
    background-image: url("/img/chat-2.png");
    background-repeat: repeat;
    flex: 1;
    background-color: #eeeeee;
    display: flex;
    flex-direction: column;
    color: #222222;
  }

  .chat-header {
    background-color: #eeeeee;
    color: #363636;
    padding: 10px;
    font-weight: bold;
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: large;
  }

  .chat-messages {
    flex: 1;
    padding: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .message {
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    max-width: 70%;
  }

  .sent-message {
    background-color: rgb(245, 245, 245);
    color: #030303;
    align-self: flex-end;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.096);
    border-radius: 10px;
    padding: 12px;
  }

  .received-message {
    background-color: #c4c4c4;
    color: #0a0a0a;
    align-self: flex-start;
    max-width: 70%;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 12px;
  }

  .message-input-container {
    display: flex;
    padding: 10px;
    background-color: #ffffff;
  }

  .message-input {
    flex: 1;
    padding: 10px;
    color: rgb(3, 3, 3);
    border-radius: 5%;
    background-color: #dddddd;
    border: 1px solid #ced1d6;
    border-radius: 5px;
  }

  .send-button {
    padding: 10px 20px;
    background-color: #186bdd;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;
  }

  .dark .chat-app {
    display: flex;
    max-width: 80%;
    height: 70vh;
    margin: 0 auto;
    background-color: #18191c;
  }

  .dark .chat-list {
    width: 20%;
    padding: 20px;
    border-radius: 5%;
    background-color: #1e2023;
    border-right: 1px solid #ccc;
    overflow-y: auto;
  }

  .dark .chat-item {
    cursor: pointer;
    padding: 10px;
    border-bottom: 1px solid #ccc;
    color: #ffffff;
  }

  .dark .chat {
    background-image: url("/img/chat.png");
    background-repeat: repeat;
    flex: 1;
    background-color: #131416;
    display: flex;
    flex-direction: column;
    color: #ffffff;
  }

  .dark .chat-header {
    background-color: #131416;
    color: #ffffff;
    padding: 10px;
    font-weight: bold;
  }

  .dark .chat-messages {
    flex: 1;
    padding: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  }

  .dark .message {
    padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    max-width: 70%;
  }

  .dark .sent-message {
    background-color: #1e2023;
    color: #ffffff;
    align-self: flex-end;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 12px;
  }

  .dark .received-message {
    background-color: #17191b;
    color: #f1f1f1;
    align-self: flex-start;
    max-width: 70%;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    padding: 12px;
  }

  .dark .message-input-container {
    display: flex;
    padding: 10px;
    background-color: #131416;
  }

  .dark .message-input {
    flex: 1;
    padding: 10px;
    color: white;
    border-radius: 5%;
    background-color: #1e2023;
    border: 1px solid #1e2023;
    border-radius: 5px;
  }

  .dark .send-button {
    padding: 10px 20px;
    background-color: #0073e6;
    color: #ffffff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 10px;
  }
</style>
